<template>
  <v-main ref="content" class="pt-0">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="0" class="mt-2">
            <v-tabs height="35" slider-size="3" :background-color="color(3)" @change="tabChanged" class="rounded-0" show-arrows v-model="selectedTab">
              <v-tab>{{ $t('toplst.tab.ttl.rt') }}</v-tab>
              <v-tab>{{ $t('toplst.tab.ttl.mem') }}</v-tab>
              <v-tab-item transition="false" reverse-transition="false">
                <v-card class="card-wrap">
                  <top-response-time :isFocus="rtFocus"></top-response-time>
                </v-card>
              </v-tab-item>
              <v-tab-item transition="false" reverse-transition="false">
                <v-card class="card-wrap">
                  <top-memory :isFocus="memFocus"></top-memory>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import TopResponseTime from './TopResponseTime.vue';
import TopMemory from './TopMemory.vue';

export default {
  components: {
    TopResponseTime,
    TopMemory,
  },
  data() {
    return {
      height: 0,
      lowerCardHeight: 0,
      rtFocus: true,
      memFocus: false,
      selectedTab: null,
    };
  },
  methods: {
    color(saturation) {
      return this.$vuetify.theme.isDark ? `grey darken-${saturation}` : `grey lighten-${saturation - 2}`;
    },
    tabChanged(index) {
      if (index == 1) {
        this.memFocus = true;
        this.rtFocus = false;
      } else {
        this.rtFocus = true;
        this.memFocus = false;
      }
    },
  },
};
</script>
